export default "__VITE_ASSET__COZS8w69__";